import { PostHogProvider as BasePostHogProvider } from "posthog-js/react";
import * as React from "react";
import { env } from "~/config/env";

interface PostHogProviderProps {
  children?: React.ReactNode;
}

export function PostHogProvider({ children }: PostHogProviderProps) {
  const options = {
    api_host: env.VITE_PUBLIC_POSTHOG_HOST,
  };

  return (
    <BasePostHogProvider apiKey={env.VITE_PUBLIC_POSTHOG_KEY} options={options}>
      {children}
    </BasePostHogProvider>
  );
}
